import React, { createContext } from 'react'
import taxTypes from '../configurations/tax-types'
import nonTaxableTaxTypes from '../configurations/non-taxable-tax-types'
import { calculateDecimal } from '../utils/helpers'
import { useDebouncedCallback } from 'use-debounce'

const InvoiceItemContext = createContext({})

const InvoiceItemProvider = ({ item, itemLineForm, documentType, children }) => {
  const [isMounted, setIsMounted] = React.useState(false)
  const [salesTotalEdit, setSalesTotalEdit] = React.useState(!!Object.keys(item || {}).length ? item.salesTotalEdit : itemLineForm.values.salesTotalEdit)
  const [discountValueEdit, setDiscountValueEdit] = React.useState(!!Object.keys(item || {}).length ? item.discountValueEdit : itemLineForm.values.discountValueEdit)
  const [totalTaxableFeesEdit, setTotalTaxableFeesEdit] = React.useState(!!Object.keys(item || {}).length ? item.totalTaxableFeesEdit : itemLineForm.values.totalTaxableFeesEdit)
  const [netTotalEdit, setNetTotalEdit] = React.useState(!!Object.keys(item || {}).length ? item.netTotalEdit : itemLineForm.values.netTotalEdit)
  const [totalEdit, setTotalEdit] = React.useState(!!Object.keys(item || {}).length ? item.totalEdit : itemLineForm.values.totalEdit)

  const [quantity, setQuantity] = React.useState(!!Object.keys(item || {}).length ? item?.quantity || 1 : itemLineForm.values.quantity)
  const [unitAmount, setUnitAmount] = React.useState(!!Object.keys(item || {}).length ? item.unitAmount || 0 : itemLineForm.values.unitAmount)
  const [salesTotal, setSalesTotal] = React.useState(!!Object.keys(item || {}).length ? item.salesTotal || 0 : itemLineForm.values.salesTotal)
  const [discountRate, setDiscountRate] = React.useState(!!Object.keys(item || {}).length ? item.discountRate || 0 : itemLineForm.values.discountRate)
  const [discountValue, setDiscountValue] = React.useState(!!Object.keys(item || {}).length ? item.discountValue || 0 : itemLineForm.values.discountValue)
  const [totalTaxableItems, setTotalTaxableItems] = React.useState(!!Object.keys(item || {}).length ? item.totalTaxableItems || 0 : itemLineForm.values.totalTaxableItems)
  const [netTotal, setNetTotal] = React.useState(!!Object.keys(item || {}).length ? item.netTotal || 0 : itemLineForm.values.netTotal)

  const [valueDifference, setValueDifference] = React.useState(item?.valueDifference || itemLineForm.values.valueDifference)
  const [itemsDiscount, setItemsDiscount] = React.useState(item?.itemsDiscount || itemLineForm.values.itemsDiscount)

  const [codeFilter, setCodeFilter] = React.useState(item?.itemCode ? {} : null)

  const handleSwitchEditChange = (value, setValue, fieldName) => {
    setValue(value)
    if (!!fieldName) {
      switch (fieldName) {
        case 'salesTotal':
          if (!value) {
            itemLineForm.setFieldValue('salesTotal', itemLineForm.values.calculatedSalesTotal)
            setSalesTotal(itemLineForm.values.calculatedSalesTotal)
          }
          itemLineForm.setFieldValue('salesTotalEdit', !!value || false)
          break
        case 'discountValue':
          if (!value) {
            itemLineForm.setFieldValue('discountValue', itemLineForm.values.discountCalculatedValue)
            setDiscountValue(itemLineForm.values.discountCalculatedValue)
          }
          itemLineForm.setFieldValue('discountValueEdit', !!value || false)
          break
        case 'totalTaxableFees':
          if (!value) {
            itemLineForm.setFieldValue('totalTaxableFees', itemLineForm.values.calculatedTotalTaxableFees)
          }
          itemLineForm.setFieldValue('totalTaxableFeesEdit', !!value || false)
          break
        case 'netTotal':
          if (!value) {
            itemLineForm.setFieldValue('netTotal', itemLineForm.values.calculatedNetTotal)
            setNetTotal(itemLineForm.values.calculatedNetTotal)
          }
          itemLineForm.setFieldValue('netTotalEdit', !!value || false)
          break
        case 'total':
          if (!value) {
            itemLineForm.setFieldValue('total', itemLineForm.values.calculatedTotal)
          }
          itemLineForm.setFieldValue('totalEdit', !!value || false)
          break
        default:
          break

      }
    }
  }
  // // Sales Total
  // React.useEffect(() => {
  //     if (!salesTotalEdit) {
  //       itemLineForm.setFieldValue('salesTotal', itemLineForm.values.calculatedSalesTotal)
  //     }
  //     itemLineForm.setFieldValue('salesTotalEdit', salesTotalEdit || false)
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [salesTotalEdit])


  // Discount value
  // React.useEffect(() => {
  //     if (!discountValueEdit) {
  //       itemLineForm.setFieldValue('discountValue', itemLineForm.values.discountCalculatedValue)
  //     }
  //     itemLineForm.setFieldValue('discountValueEdit', discountValueEdit || false)
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [discountValueEdit])


  // React.useEffect(() => {
  //     if (!totalTaxableFeesEdit) {
  //       itemLineForm.setFieldValue('totalTaxableFees', itemLineForm.values.calculatedTotalTaxableFees)
  //     }
  //     itemLineForm.setFieldValue('totalTaxableFeesEdit', totalTaxableFeesEdit || false)
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [totalTaxableFeesEdit])

  // React.useEffect(() => {
  //     if (!netTotalEdit) {
  //       itemLineForm.setFieldValue('netTotal', itemLineForm.values.calculatedNetTotal)
  //     }
  //     itemLineForm.setFieldValue('netTotalEdit', netTotalEdit || false)
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [netTotalEdit])

  // React.useEffect(() => {
  //     if (!totalEdit) {
  //       itemLineForm.setFieldValue('total', itemLineForm.values.calculatedTotal)
  //     }
  //     itemLineForm.setFieldValue('totalEdit', totalEdit || false)
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [totalEdit])

  const updateTotalTaxableFees = (taxesList) => {
    if (!!taxesList?.length) {
      let allTaxes = [...taxTypes, ...nonTaxableTaxTypes]
      let allNoFeesTaxes = allTaxes?.filter(item => !!item?.noFees)?.map(item => item.key)
      let allWithdrawTaxes = allTaxes?.filter(item => !!item?.withdraw)?.map(item => item.key)
      let calculatedFees = 0
      let calculatedTaxes = 0
      let calculatedTaxesWithoutT1 = 0
      taxesList.forEach((item) => {
        if (!allNoFeesTaxes.includes(item.type)) {
          calculatedFees += parseFloat(item.value) || 0
        }
        if (!!allWithdrawTaxes.includes(item.type)) {
          calculatedTaxes -= parseFloat(item.value) || 0
          // calculatedTaxesWithoutT1 -= (item.type === 'T1') ? 0 : parseFloat(item.value) || 0
        } else {
          calculatedTaxes += parseFloat(item.value) || 0
          calculatedTaxesWithoutT1 += (nonTaxableTaxTypes.map(item => item.key).includes(item.type) || (item.type === 'T1')) ? 0 : parseFloat(item.value) || 0
        }
      })

      itemLineForm.setFieldValue('calculatedTotalTaxableFees', calculateDecimal(calculatedFees))
      itemLineForm.setFieldValue('totalTaxableItems', calculateDecimal(calculatedTaxes))
      itemLineForm.setFieldValue('calculatedTaxesWithoutT1', calculateDecimal(calculatedTaxesWithoutT1))
      setTotalTaxableItems(calculatedTaxes)
      if (!totalTaxableFeesEdit) {
        itemLineForm.setFieldValue('totalTaxableFees', calculateDecimal(calculatedFees))
      }
    } else {
      itemLineForm.setFieldValue('calculatedTotalTaxableFees', calculateDecimal(0))
      itemLineForm.setFieldValue('totalTaxableItems', calculateDecimal(0))
      itemLineForm.setFieldValue('calculatedTaxesWithoutT1', calculateDecimal(0))
      setTotalTaxableItems(0)
      if (!totalTaxableFeesEdit) {
        itemLineForm.setFieldValue('totalTaxableFees', calculateDecimal(0))
      }
    }
  }
  React.useEffect(() => {
      if (!!Object.keys(item || {}).length) {
        setCodeFilter(item?.itemCode ? { 'CodeLookupValue': item?.itemCode } : null)
        itemLineForm.setValues({
          'id': item?.id || '',
          'documentType': documentType || '',
          'itemType': item?.itemType || 'GS1',
          'itemCode': item?.itemCode || '',
          'description': item?.description || '',
          'itemObject': {},
          'codeFilter': {
            CodeLookupValue: item?.itemCode || '',
            CodeName: '',
            OnlyActive: false
          },
          'internalCode': item?.internalCode || '',
          'unitCalculatedValue': item?.unitCalculatedValue || 0,
          'unitAmount': item?.unitAmount || 0,
          'currencyRate': item?.currencyRate || {
            id: 0,
            key: 'EGP',
            name_en: 'Egyptian Pound',
            name_ar: 'جنيه مصري',
            rate: 1
          },
          'amountSold': item?.amountSold || 'EGP',
          'unitType': item?.unitType || 'KGM',
          'quantity': item?.quantity || 1,
          'weightUnitType': item?.weightUnitType || '',
          'weightQuantity': item?.weightQuantity || 0,
          'calculatedSalesTotal': item?.calculatedSalesTotal || 0,
          'salesTotalEdit': item?.salesTotalEdit || false,
          'salesTotal': item?.salesTotal || 0,
          'discountRate': item?.discountRate || 0,
          'discountValue': item?.discountValue || 0,
          'discountValueEdit': item?.discountValueEdit || false,
          'discountCalculatedValue': item?.discountCalculatedValue || 0,
          'netTotal': item?.netTotal || 0,
          'netTotalEdit': item?.netTotalEdit || false,
          'calculatedNetTotal': item?.calculatedNetTotal || 0,
          'taxableItems': item?.taxableItems || [],
          'totalTaxableItems': item?.totalTaxableItems || 0,
          'calculatedTaxesWithoutT1': item?.calculatedTaxesWithoutT1 || 0,
          'totalTaxableFees': item?.totalTaxableFees || 0,
          'totalTaxableFeesEdit': item?.totalTaxableFeesEdit || false,
          'calculatedTotalTaxableFees': item?.calculatedTotalTaxableFees || 0,
          'valueDifference': item?.valueDifference || 0,
          'itemsDiscount': item?.itemsDiscount || 0,
          'total': item?.total || 0,
          'totalEdit': item?.totalEdit || false,
          'calculatedTotal': item?.calculatedTotal || 0,
          'deleted': itemLineForm.values.deleted,
          'invoiceUUID': item.invoiceUUID || '',
          'originItemValues': item?.originItemValues || null
        })
      }
      setIsMounted(true)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])


  // React.useEffect(() => {
  //     let value = (parseFloat(itemLineForm.values.quantity) || 0) * (parseFloat(itemLineForm.values.unitAmount) || 0)
  //     itemLineForm.setFieldValue('calculatedSalesTotal', calculateDecimal(value))
  //     if (!salesTotalEdit) {
  //       itemLineForm.setFieldValue('salesTotal', calculateDecimal(value))
  //       // setSalesTotal(calculateDecimal(value))
  //     }
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [itemLineForm.values.quantity, itemLineForm.values.unitAmount])
  //
  //
  // React.useEffect(() => {
  //     let value = (parseFloat(itemLineForm.values.salesTotal) || 0) * ((parseFloat(itemLineForm.values.discountRate) || 0) / 100)
  //     itemLineForm.setFieldValue('discountCalculatedValue', calculateDecimal(value))
  //     if (!discountValueEdit) {
  //       itemLineForm.setFieldValue('discountValue', calculateDecimal(value))
  //       // setDiscountValue(calculateDecimal(value))
  //     }
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [itemLineForm.values.salesTotal, itemLineForm.values.discountRate])
  //
  // React.useEffect(() => {
  //     let value = (parseFloat(itemLineForm.values.salesTotal) || 0) - (parseFloat(itemLineForm.values.discountValue) || 0)
  //     itemLineForm.setFieldValue('calculatedNetTotal', calculateDecimal(value))
  //     if (!netTotalEdit) {
  //       itemLineForm.setFieldValue('netTotal', calculateDecimal(value))
  //       // setNetTotal(calculateDecimal(value))
  //     }
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [itemLineForm.values.salesTotal, itemLineForm.values.discountValue])
  //
  //
  // React.useEffect(() => {
  //     let value = (parseFloat(itemLineForm.values.netTotal) || 0) + (parseFloat(itemLineForm.values.totalTaxableItems) || 0)
  //     itemLineForm.setFieldValue('calculatedTotal', calculateDecimal(value))
  //     if (!totalEdit) {
  //       itemLineForm.setFieldValue('total', calculateDecimal(value))
  //     }
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [itemLineForm.values.totalTaxableItems, itemLineForm.values.netTotal])

  React.useEffect(() => {
      if (!!isMounted) {
        let value = (parseFloat(quantity) || 0) * (parseFloat(unitAmount) || 0)
        itemLineForm.setFieldValue('calculatedSalesTotal', calculateDecimal(value))
        if (!salesTotalEdit) {
          itemLineForm.setFieldValue('salesTotal', calculateDecimal(value))
          setSalesTotal(calculateDecimal(value))
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [quantity, unitAmount])


  React.useEffect(() => {
      if (!!isMounted) {
        let value = (parseFloat(salesTotal) || 0) * ((parseFloat(discountRate) || 0) / 100)
        itemLineForm.setFieldValue('discountCalculatedValue', calculateDecimal(value))
        if (!discountValueEdit) {
          itemLineForm.setFieldValue('discountValue', calculateDecimal(value))
          setDiscountValue(calculateDecimal(value))
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [salesTotal, discountRate])

  React.useEffect(() => {
      if (!!isMounted) {
        let value = (parseFloat(salesTotal) || 0) - (parseFloat(discountValue) || 0)
        itemLineForm.setFieldValue('calculatedNetTotal', calculateDecimal(value))
        if (!netTotalEdit) {
          itemLineForm.setFieldValue('netTotal', calculateDecimal(value))
          setNetTotal(calculateDecimal(value))
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [salesTotal, discountValue])
  //
  //
  React.useEffect(() => {
      if (!!isMounted) {
        let value = (parseFloat(netTotal) || 0) + (parseFloat(totalTaxableItems) || 0) - (parseFloat(itemsDiscount) || 0)
        itemLineForm.setFieldTouched('total', true)
        itemLineForm.setFieldValue('calculatedTotal', calculateDecimal(value))
        if (!totalEdit) {
          itemLineForm.setFieldValue('total', calculateDecimal(value))
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [totalTaxableItems, netTotal, valueDifference, itemsDiscount])

  const debouncedChange = useDebouncedCallback((fieldName, value) => {
    setFieldCalculations(fieldName, value)
  }, 100)

  React.useEffect(() => () => {
      debouncedChange.flush()
    },
    [debouncedChange])

  const DecimalChange = (event, fieldName, negative) => {
    let re = /^[0-9]*\.?[0-9]*$/
    if (!!negative) {
      re = /^-?[0-9]*\.?[0-9]*$/
    }
    if (event.target.value === '' || re.test(event.target.value)) {
      itemLineForm.setFieldValue(fieldName, event.target.value)
      debouncedChange(fieldName, event.target.value)
      // setFieldCalculations(fieldName, event.target.value)
    }
  }

  const DecimalBlur = (event, fieldName) => {
    let value = calculateDecimal(event.target.value)
    itemLineForm.setFieldValue(fieldName, value)
    setFieldCalculations(fieldName, event.target.value)
  }

  const RateChange = (event, fieldName) => {
    // const re = /^[1-9][0-9]?(\.[0-9]*)?$|^100(\.[0]*)?$/
    const re = /^([1-9])*[0-9]?(\.[0-9]*)?$|^100(\.[0]*)?$/
    if (event.target.value === '' || re.test(event.target.value)) {
      itemLineForm.setFieldValue(fieldName, event.target.value)
      debouncedChange(fieldName, event.target.value)
    }
  }

  const setFieldCalculations = (fieldName, fieldValue) => {
    if (!!fieldName) {
      switch (fieldName) {
        case 'quantity':
          setQuantity(fieldValue || 0)
          // calculateSalesTotal(fieldValue || 0, true)
          break
        case 'unitAmount':
          setUnitAmount(fieldValue || 0)
          // calculateSalesTotal(fieldValue || 0)
          break
        case 'salesTotal':
          setSalesTotal(fieldValue || 0)
          // calculateDiscount(fieldValue || 0, true)
          // calculateNetTotal(fieldValue || 0, true)
          break
        case 'discountRate':
          setDiscountRate(fieldValue || 0)
          // calculateDiscount(fieldValue || 0)
          break
        case 'discountValue':
          setDiscountValue(fieldValue || 0)
          // calculateNetTotal(fieldValue || 0)
          break
        case 'totalTaxableItems':
          setTotalTaxableItems(fieldValue || 0)
          // calculateTotal(fieldValue || 0)
          break
        case 'netTotal':
          setNetTotal(fieldValue || 0)
          // calculateTotal(fieldValue || 0, true)
          break
        case 'valueDifference':
          setValueDifference(fieldValue || 0)
          // calculateTotal(fieldValue || 0, true)
          break
        case 'itemsDiscount':
          setItemsDiscount(fieldValue || 0)
          // calculateTotal(fieldValue || 0, true)
          break
        default:
          break
      }
    }
  }

  // const calculateSalesTotal = (value, isQuantity) => {
  //   let calculatedSalesTotal = (parseFloat(value || (isQuantity ? quantity : unitAmount)) || 0) * (parseFloat((isQuantity ? unitAmount : quantity)) || 0)
  //   itemLineForm.setFieldValue('calculatedSalesTotal', calculateDecimal(calculatedSalesTotal))
  //   if (!totalEdit) {
  //     itemLineForm.setFieldValue('salesTotal', calculateDecimal(calculatedSalesTotal))
  //     setSalesTotal(calculateDecimal(calculatedSalesTotal))
  //     calculateDiscount(calculateDecimal(calculatedSalesTotal), true)
  //   } else {
  //     calculateDiscount()
  //   }
  // }
  //
  // const calculateDiscount = (value, isSalesTotal) => {
  //   let calculatedDiscount = isSalesTotal ? ((parseFloat(value || salesTotal) || 0) * ((parseFloat(discountRate) || 0) / 100)) : ((parseFloat(salesTotal) || 0) * ((parseFloat(value || discountRate) || 0) / 100))
  //   itemLineForm.setFieldValue('discountCalculatedValue', calculateDecimal(calculatedDiscount))
  //   if (!totalEdit) {
  //     itemLineForm.setFieldValue('discountValue', calculateDecimal(calculatedDiscount))
  //     setDiscountValue(calculateDecimal(calculatedDiscount))
  //     calculateNetTotal(calculateDecimal(calculatedDiscount))
  //   } else {
  //     calculateNetTotal()
  //   }
  // }
  // const calculateNetTotal = (value, isSalesTotal) => {
  //   let calculatedNetTotal = isSalesTotal ? ((parseFloat(value || salesTotal) || 0) - (parseFloat(discountValue) || 0)) : ((parseFloat(salesTotal) || 0) - (parseFloat(value || discountValue) || 0))
  //   itemLineForm.setFieldValue('calculatedNetTotal', calculateDecimal(calculatedNetTotal))
  //   if (!totalEdit) {
  //     itemLineForm.setFieldValue('netTotal', calculateDecimal(calculatedNetTotal))
  //     setNetTotal(calculateDecimal(calculatedNetTotal))
  //     calculateTotal(calculateDecimal(calculatedNetTotal), true)
  //   } else {
  //     calculateTotal()
  //   }
  // }
  // const calculateTotal = (value, isNetTotal) => {
  //   let calculatedTotal = (parseFloat(value || (isNetTotal ? netTotal : totalTaxableItems)) || 0) + (parseFloat((isNetTotal ? totalTaxableItems : netTotal)) || 0)
  //   itemLineForm.setFieldValue('calculatedTotal', calculateDecimal(calculatedTotal))
  //   if (!totalEdit) {
  //     itemLineForm.setFieldValue('total', calculateDecimal(calculatedTotal))
  //   }
  // }

  return (
    <InvoiceItemContext.Provider value={{
      item,
      codeFilter,

      DecimalBlur,
      DecimalChange,
      handleSwitchEditChange,
      RateChange,
      updateTotalTaxableFees,


      discountValueEdit,
      setDiscountValueEdit,

      salesTotalEdit,
      setSalesTotalEdit,

      totalTaxableFeesEdit,
      setTotalTaxableFeesEdit,

      netTotalEdit,
      setNetTotalEdit,

      totalEdit,
      setTotalEdit

    }}>
      {children}
    </InvoiceItemContext.Provider>
  )
}
const InvoiceItemConsumer = InvoiceItemContext.Consumer

export { InvoiceItemProvider, InvoiceItemConsumer }
